"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.__internal__setErrorThrowerOptions = exports.ClerkProvider = void 0;
var ClerkProvider_1 = require("./ClerkProvider");
Object.defineProperty(exports, "ClerkProvider", { enumerable: true, get: function () { return ClerkProvider_1.ClerkProvider; } });
Object.defineProperty(exports, "__internal__setErrorThrowerOptions", { enumerable: true, get: function () { return ClerkProvider_1.__internal__setErrorThrowerOptions; } });
